module.exports = __webpack_public_path__ + "static/media/СЗФО_2004.e61881b1.png";